import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { saveMedicalConsult } from '../../procedures/medicalConsult/store/medicalConsult.actions'
import { QuickActionsConstants } from '../store/quickActions.constants'

export function* setMedicalConsultQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addMedicalConsultToTimeline } = quickActionsObject
  if (addMedicalConsultToTimeline) {
    yield put(saveMedicalConsult())
  }
}

export function* setMedicalConsultQuickActionTimeLineRowSaga() {
  yield takeLatest([QuickActionsConstants.SET_ADD_MEDICAL_CONSULT_TO_TIMELINE], setMedicalConsultQuickActionTimeLineRow)
}
